// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__2XAj3","wrapper":"Header_wrapper__36R_A","nielsen":"Header_nielsen__NMaQC","divider":"Header_divider__kI84V"};